import {
  HIGHLIGHT_SPEAKER_LABEL,
  type Highlight,
} from '@/shared/types/highlight'
import { ConversationLine } from './ConversationLine'

interface Props {
  highlight: Highlight
  // 0..1、HighlightList の newest-N flow で古い行を fade させる用。
  opacity?: number
}

const formatOffset = (sec: number): string => {
  const m = Math.floor(sec / 60)
  const s = Math.floor(sec % 60)
  return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
}

// ハイライト 1 件 (= AI 抽出の要点)。 spacious な ConversationLine で描く。
// 全文の「発話」は compact 表示にして重み差で見分ける。
export const HighlightCard = ({ highlight, opacity = 1 }: Props) => (
  <ConversationLine
    speaker={HIGHLIGHT_SPEAKER_LABEL[highlight.speaker]}
    time={formatOffset(highlight.span_sec)}
    text={highlight.text}
    isInterim={highlight.is_interim === true}
    opacity={opacity}
  />
)
